import { ChangeDetectorRef, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import _ from 'lodash';
import { forkJoin, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectDialogState } from '../../../../dialog/features/dialog.selectors';
import { DialogService } from '../../../../dialog/services/dialog.service';
import { selectAuctionCampaignList } from '../../../../campaign/features/campaign.selectors';
import { filter, map } from 'rxjs/operators';
import { CampaignService, PresetOptionsService } from '../../../../campaign/services';
import {
  loadEditCampaignList,
  putCampaignSuccess,
} from '../../../../campaign/features/campaign.actions';
import { SharedService } from '../../../../virtual-event/services/shared.service';
import { ToastService } from '../../../../toast/services/toast.service';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
import { IPresetOption } from '../../../../event/models/event.model';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbpInputComponent } from '../../mdb-input/mdb-input.component';
import { MdbTextareaComponent } from '../../mdb-textarea/mdb-textarea.component';
import { IconSuccessComponent } from 'app/icon/components/icon-success/icon-success.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { IconCopyUnsoldComponent } from 'app/icon/components/icon-copy-unsold/icon-copy-unsold.component';
import { IconCopyAllComponent } from 'app/icon/components/icon-copy-all/icon-copy-all.component';
import { IconCopySomeComponent } from 'app/icon/components/icon-copy-some/icon-copy-some.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';

export enum COPY_TYPES {
  FULL_COPY_TO_NEW = 0,
  PARTLY_COPY_TO_NEW = 1,
  PARTLY_COPY_TO_EXISTING = 2,
  COPY_UNSOLD_TO_NEW = 3,
  COPY_UNSOLD_TO_EXISTING = 4,
}

@Component({
  standalone: true,
  imports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    MdbpInputComponent,
    MdbTextareaComponent,
    IconSuccessComponent,
    IconCopyUnsoldComponent,
    IconCopyAllComponent,
    IconCopySomeComponent,
    MdbSelectModule,
    MdbFormsModule,
    MdbSelectModule,
    NgxPaginationModule,
    MdbValidationModule,
  ],  
  selector: 'app-copy-campaign',
  templateUrl: './copy-campaign.component.html',
  styleUrls: ['./copy-campaign.component.scss']
})
export class CopyCampaignComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public p: number = 1;
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  public title = '';
  public step = 0;
  public dialog;
  public campaign;
  public finalCampaign;
  public isAllSelected = false;
  public copyType;
  public copyTypes = COPY_TYPES;
  public selectedCampaign;
  public selectedCount = 0;
  public selectedUnSoldCount = 0;
  public selectedOptions = [];
  public selectedUnSoldOptions = [];
  public fullCopyForm: UntypedFormGroup;
  public partlyCopyToExistingForm: UntypedFormGroup;
  public partlyCopyToNewForm: UntypedFormGroup;
  public copyUnSoldToNewForm: UntypedFormGroup;
  public copyUnSoldToExistingForm: UntypedFormGroup;
  public campaignName: string;
  public filteredOptions = [];
  public unsoldOptions = [];
  public unsoldFilteredOptions = [];
  public search: UntypedFormControl = new UntypedFormControl('', []);

  public copyCampaignOptions: any = [{
    id: 0,
    title: 'Copy All To New Auction Campaign',
    description: 'All items from this auction will be copied to a new auction',
    type: COPY_TYPES.FULL_COPY_TO_NEW,
    selected: false,
    available:true
  }, {
    id: 1,
    title: 'Copy Some To New Auction Campaign',
    description: 'Some items from this auction will be copied to a new auction',
    type: COPY_TYPES.PARTLY_COPY_TO_NEW,
    selected: false,
    available:true
  }, {
    id: 2,
    title: 'Copy Some To Existing Auction Campaign',
    description: 'Some items from this auction will be copied to a existing auction',
    type: COPY_TYPES.PARTLY_COPY_TO_EXISTING,
    selected: false,
    available:true
  },{ id: 3,
    title: 'Copy Unsold To New Auction Campaign',
    description: 'Some unsold items from this auction will be copied to a new auction',
    type: COPY_TYPES.COPY_UNSOLD_TO_NEW,
    selected: false,
    available:true
  },{ id: 4,
    title: 'Copy Unsold Items To Existing Campaign',
    description: 'Some unsold items from this auction will be copied to a existing auction',
    type: COPY_TYPES.COPY_UNSOLD_TO_EXISTING,
    selected: false,
    available:true
  }]

  public auctions$: any = this.store.pipe(
    select(selectAuctionCampaignList),
    filter(() => this.campaign),
    map(list => {
      const filteredList = _.filter(list, (auction) => {
        if(auction.status === 5) {
          return false;
        }

        if(auction.id === this.campaign.id) {
          return false;
        }
        
        return auction.campaignTypeData.auctionType === this.campaign.campaignTypeData.auctionType;
      });
      

      return filteredList.sort((a, b) => b.updated - a.updated);;
    })
  );

  constructor(
    public updates$: Actions,
    private router: Router,
    private store: Store,
    private dialogService: DialogService,
    private campaignService: CampaignService,
    private sharedService: SharedService,
    private toastService: ToastService,
    private fb: UntypedFormBuilder,
    private presetOptionsService: PresetOptionsService,
    private cdr: ChangeDetectorRef,
  ) {
    this.fullCopyForm = this.fb.group({
      auctionName: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
    });

    this.partlyCopyToExistingForm = this.fb.group({
      campaign: new UntypedFormControl(null, [Validators.required]),
    });

    this.partlyCopyToNewForm = this.fb.group({
      newAuctionName: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
    });

    this.copyUnSoldToNewForm = this.fb.group({
      newAuctionName: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
    });

    this.copyUnSoldToExistingForm = this.fb.group({
      campaign: new UntypedFormControl(null, [Validators.required]),
    });

    this.updates$.pipe(
      ofType(
        putCampaignSuccess.type
      ),
      takeUntilDestroyed()
    ).subscribe((action: { type: string; data: any }) => {
      this.store.dispatch({
        type: loadEditCampaignList.type,
        payload: this.sharedService.token
      });
      this.toastService.show('success', 'Selected Campaign updated')
    });

    this.auctions$.pipe(
      takeUntilDestroyed()
    ).subscribe((list) => {
      if (this.selectedCampaign?.id) {
        this.finalCampaign = _.find(list, (campaign) => campaign.id === this.selectedCampaign.id)
      }
    });
  }

  ngOnInit(): void {
    this.dialog$.subscribe((dialog) => {
      this.dialog = dialog;
      if (this.dialog.initialState && this.dialog.initialState.campaign) {
        this.title = `How would you like to copy <span> ${dialog.initialState.campaign.name}</span> items?`;
        this.campaign = this.dialog.initialState.campaign;
        if (this.campaign.campaignTypeData.presetOptions?.length) {
          this.campaign.campaignTypeData.presetOptions.map(option => {
            option.checked = true;
            return option;
          });

          this.filteredOptions = this.campaign.campaignTypeData.presetOptions;
          this.unsoldOptions = this.campaign.campaignTypeData.presetOptions.filter(opt=>(opt.soldCount < opt.count));
          this.unsoldFilteredOptions = this.campaign.campaignTypeData.presetOptions.filter(opt=>(opt.soldCount < opt.count));
  
          this.selectedCount = this.campaign.campaignTypeData.presetOptions.length;
          this.selectedUnSoldCount = this.unsoldFilteredOptions.length;

          this.selectedOptions = this.campaign.campaignTypeData.presetOptions
          this.selectedUnSoldOptions = this.campaign.campaignTypeData.presetOptions.filter(opt=>(opt.soldCount < opt.count));
          
          if(this.selectedUnSoldOptions.length == 0){
            this.copyCampaignOptions = this.copyCampaignOptions.map(opt=>{
              if(opt.id == 3 || opt.id == 4){
                opt.available = false;
              }
              return {...opt}
            })
        }
          this.cdr.markForCheck();
          
          this.isAllSelected = true;
        }
      }
    });

    this.search.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(search => {
      this.filteredOptions = _.filter(this.campaign.campaignTypeData.presetOptions, (presetOption: IPresetOption) => {
        return _.includes(presetOption.name.toLowerCase(), search.toLowerCase()) ||
          _.includes(presetOption.desc.toLowerCase(), search.toLowerCase());
      });

      this.unsoldFilteredOptions = _.filter(this.unsoldOptions, (presetOption: IPresetOption) => {
        return _.includes(presetOption.name.toLowerCase(), search.toLowerCase()) ||
          _.includes(presetOption.desc.toLowerCase(), search.toLowerCase());
      });

      this.p = 1;
    });
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
    this.finalCampaign = null;
    this.selectedCampaign = null;
    this.selectedOptions = null;
  }

  resetSearch() {
    this.search.setValue('');
  }

  onNextStep(): void {
    this.step += 1;
  }

  onPrevStep(): void {
    this.step -= 1;

    if (this.step === 0) {
      this.title = `How would you like to copy <span> ${this.dialog.initialState.campaign.name}</span> items?`;
    }
  }

  onChooseCopyType(type): void {
    this.step += 1;
    this.copyType = type;

    switch (type) {
      case 0:
        this.title = `Copying All From <span> ${this.dialog.initialState.campaign.name}</span> Items To New Auction Campaign`;
        break;
      case 1:
        this.title = `Copying Some From <span> ${this.dialog.initialState.campaign.name}</span> Items To New Auction Campaign`;
        break;
      case 2:
        this.title = `Copying Some From <span> ${this.dialog.initialState.campaign.name}</span> Items To Existing Auction Campaign`;
        break;
      case 3:
        this.title = `Copying Unsold Items From <span> ${this.dialog.initialState.campaign.name}</span> To  New Auction Campaign`;
        break;
      case 4:
        this.title = `Copying Unsold Items From <span> ${this.dialog.initialState.campaign.name}</span> To Existing Auction Campaign`;
        break;
    }
  }

  onChange(event, id): void {
    if (this.campaign.campaignTypeData.presetOptions?.length && this.copyType !== this.copyTypes.COPY_UNSOLD_TO_NEW && this.copyType !== this.copyTypes.COPY_UNSOLD_TO_EXISTING) {
      const option = this.campaign.campaignTypeData.presetOptions.find(opt => opt.id === id)
      option.checked = !option.checked;
      this.selectedOptions = this.campaign.campaignTypeData.presetOptions.filter(opt => opt.checked === true);
      this.selectedCount = this.selectedOptions?.length || 0;
    }

    if(this.unsoldOptions?.length && this.copyType === this.copyTypes.COPY_UNSOLD_TO_NEW || this.unsoldOptions?.length && this.copyType === this.copyTypes.COPY_UNSOLD_TO_EXISTING){
      const option = this.unsoldOptions.find(opt => opt.id === id)
      option.checked = !option.checked;
      this.selectedUnSoldOptions = this.unsoldOptions.filter(opt => opt.checked === true);
      this.selectedUnSoldCount = this.selectedUnSoldOptions?.length || 0;
    }
  }

  getCountText(option){
    return `Unsold Count: ${option.count - option.soldCount}`
  }

  selectAll(): void {
    this.campaign.campaignTypeData.presetOptions.map(option => {
      option.checked = true;
      return option;
    });

    this.unsoldOptions.map(option => {
      option.checked = true;
      return option;
    });

    this.isAllSelected = true;
    this.selectedCount = this.campaign.campaignTypeData.presetOptions.length;
    this.selectedOptions = this.campaign.campaignTypeData.presetOptions;

    this.selectedUnSoldCount = this.unsoldOptions.length;
    this.selectedUnSoldOptions = this.unsoldOptions;


  }

  unSelectAll(): void {
    this.campaign.campaignTypeData.presetOptions.map(option => {
      option.checked = false;
      return option;
    });

    this.unsoldOptions.map(option => {
      option.checked = false;
      return option;
    });

    this.isAllSelected = false;

    this.selectedCount = 0;
    this.selectedOptions = [];

    this.selectedUnSoldCount = 0;
    this.selectedUnSoldOptions = [];
  }

  copyCampaign(type): void {
    switch (type) {
      case 0:
        this.onFullCopy().subscribe((campaign) => {
          this.store.dispatch({
            type: loadEditCampaignList.type,
            payload: this.sharedService.token
          });

          this.finalCampaign = campaign;
          this.selectedCampaign = campaign;

          this.toastService.show('success', 'New campaign created')
          this.step = 3;
        });

        break;
      case 1:
        this.onCreateNewCampaignWithExistingOptions().subscribe((campaign) => {
          this.store.dispatch({
            type: loadEditCampaignList.type,
            payload: this.sharedService.token
          });

          this.finalCampaign = campaign;
          this.selectedCampaign = campaign;

          this.toastService.show('success', 'New campaign created')
          this.onNextStep();
        });
        break;
      case 2:
        this.onCopyOptionsToExistingCampaign().subscribe(() => {
          this.store.dispatch({
            type: loadEditCampaignList.type,
            payload: this.sharedService.token,
            statusFilter: 0,
            campaignTypes: [CAMPAIGN_TYPE.AUCTION]
          });

          this.finalCampaign = this.selectedCampaign;

          this.toastService.show('success', 'Options added')
          this.onNextStep();
        });
        break;
      case 3:
        this.onCreateNewCampaignWithExistingUnSoldOptions().subscribe((campaign) => {
          this.store.dispatch({
            type: loadEditCampaignList.type,
            payload: this.sharedService.token
          });

          this.finalCampaign = campaign;
          this.selectedCampaign = campaign;

          this.toastService.show('success', 'New campaign created')
          this.onNextStep();
        });
        break;
      case 4:
        this.onCopyUnSoldOptionsToExistingCampaign().subscribe(() => {
          this.store.dispatch({
            type: loadEditCampaignList.type,
            payload: this.sharedService.token,
            statusFilter: 0,
            campaignTypes: [CAMPAIGN_TYPE.AUCTION]
          });

          this.finalCampaign = this.selectedCampaign;

          this.toastService.show('success', 'Options added')
          this.onNextStep();
        });
        break;
    }
  }

  onFullCopy(): Observable<any> {
    this.campaignName = this.fullCopyForm.get('auctionName').value || 'New Campaign'

    return this.campaignService.deepCopyCampaign({
      name: this.campaignName,
      campaignId: this.campaign.id
    });
  }

  onCreateNewCampaignWithExistingOptions(): Observable<any> {
    const optionIds = _.map(this.selectedOptions, option => option.id);
    this.campaignName = this.partlyCopyToNewForm.get('newAuctionName').value || 'New Campaign'

    return this.campaignService.deepCopyCampaign({
      name: this.campaignName,
      campaignId: this.campaign.id,
      optionIds
    });
  }

  onCreateNewCampaignWithExistingUnSoldOptions(): Observable<any> {
    const optionIds = _.map(this.selectedUnSoldOptions, option => option.id);
    this.campaignName = this.copyUnSoldToNewForm.get('newAuctionName').value || 'New Campaign'

    return this.campaignService.deepCopyCampaign({
      name: this.campaignName,
      campaignId: this.campaign.id,
      optionIds,
      useUnsoldCount:true
    });
  }

  onCopyOptionsToExistingCampaign(): Observable<any> {
    this.selectedCampaign = this.partlyCopyToExistingForm.get('campaign').value;
    this.campaignName = this.selectedCampaign.name;

    return forkJoin(
      _.map(this.selectedOptions, (option) => this.presetOptionsService.addPresetOption({ id: this.selectedCampaign.id }, option)
      ));
  }

  onCopyUnSoldOptionsToExistingCampaign(): Observable<any> {
    this.selectedCampaign = this.copyUnSoldToExistingForm.get('campaign').value;
    this.campaignName = this.selectedCampaign.name;
    let updatedSoldCountOptions = this.selectedUnSoldOptions.map((opt)=>{
      opt.count =  opt.count - opt.soldCount
      return opt
    })
    return forkJoin(
      _.map(updatedSoldCountOptions, (option) => this.presetOptionsService.addPresetOption({ id: this.selectedCampaign.id }, option)
      ));
  }

  close(dialog, value) {
    try {
      this.dialogService.modalRef.close();
      this.dialogService.closeDialogSubject.next(value);
    } catch (e) {
    }

    const { initialState: { action, callback } } = dialog;
    if (value) {
      if (action) {
        this.store.dispatch(action);
      }
    }
    callback(value);
  }

  onEditCampaign() {
    let name = null;
    switch (this.finalCampaign.type) {
      case 0:
        name = 'donation';
        break;
      case 3:
        name = 'hindu-temple-puja';
        break;
      case 4:
        name = 'auction';
        break;
      case 6:
        name = 'ticketing';
        break;
      case 7:
        name = 'long-pledge';
        break;
      case 8:
        name = 'peer-to-peer-fundraising';
        break;
      case 9:
        name = 'last-hero';
        break;
    }

    this.close(this.dialog, false);
    this.router.navigateByUrl(`campaign/${name}/${this.finalCampaign.id}`);
  }

  onSelect(copyOptionId) {
    this.copyCampaignOptions = this.copyCampaignOptions.map((option) => {
      return {
        ...option,
        selected: option.id === copyOptionId
      };
    });
  }
}
